import api from '@/helpers/api';

export interface AddProfileNoteDto {
	content: string;
}

export interface AddProfileNoteResponseDto {
	noteId: string;
}

export interface UpdateProfileNoteDto {
	content: string;
}

export const createWorkerNote = async (
	workerId: string,
	body: AddProfileNoteDto
): Promise<AddProfileNoteResponseDto> => {
	const response = await api.request<AddProfileNoteResponseDto>({
		url: `/workers/${workerId}/notes`,
		method: 'POST',
		data: body,
	});
	return response.data;
};

export const updateWorkerNote = async (
	workerId: string,
	noteId: string,
	body: UpdateProfileNoteDto
): Promise<void> => {
	await api.request<void>({
		url: `/workers/${workerId}/notes/${noteId}`,
		method: 'PATCH',
		data: body,
	});
};

export default {
	createWorkerNote,
	updateWorkerNote,
};
